export default __webpack_public_path__ + "static/media/programming.2a346fe6.gif";